import styled from 'styled-components';

import Lock from '@m/assets/svg/lock';
import { Button } from '@m/components/uikit';
import withStyledSystem from '@m/theme/helpers/withStyledSystem';

import type { StyledSystemProps } from '@m/theme/helpers/withStyledSystem';

export const PayButton = styled(Button)<StyledSystemProps>`
  width: 100%;
  height: 72px;
  box-shadow: none;
  font-size: 18px;
  line-height: 1;
  font-weight: 600;
  letter-spacing: 0.02em;
  color: #fff;
  padding: 0 44px;
  position: relative;

  &:disabled {
    opacity: 0.35;
    filter: none;
  }
  ${withStyledSystem}
`;

export const LockIcon = styled(Lock)<StyledSystemProps>`
  display: block;
  width: 24px;
  height: 24px;
  position: absolute;
  top: 50%;
  right: 16px;
  margin-top: -14px;
  fill: currentColor;
  ${withStyledSystem}
`;
